module.exports = __webpack_public_path__ + "static/media/location.59c8c2ac.svg";